/* eslint-disable */


/**
 * Create styles for `<OrderConfirmationMessage />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<OrderConfirmationMessage />` styles
 */
const orderConfirmationMessageStyles = ({ theme }) => ({});

export default orderConfirmationMessageStyles;
